import {createStore} from 'vuex'

export default createStore({
    state: {
        sidebarData: [],
        thisUserData: {}
    },
    mutations: {
        updateSidebarData(state, newSidebarData) {
            state.sidebarData = newSidebarData
        },
        updateThisUserData(state, newThisUserData) {
            state.thisUserData = newThisUserData
        }
    },
    getters: {
        sidebarData: state => state.sidebarData,
        userData: state => state.thisUserData,
        hasClearance: (state) => (requiredClearance) => {
            return state.sidebarData.includes(requiredClearance);
        }
    }
})